import { api } from './api'

// { seen: [id], steps: [id], off: bool }
export function getHelp() {
  return api.get('/users/me/help').then((data) => data.help)
}

// { seen?: [id], steps?: [id], off?: bool, reset?: true }
export function updateHelp(changes) {
  return api.patch('/users/me/help', changes).then((data) => data.help)
}
